import { graphql } from 'react-relay';

export default graphql`
  query HomePage_Query {
    viewer {
      id
      id
      ...HomePage_viewer
    }
  }
`;
